<template>
  <footer class="footer">
    <div class="footer-container">
      <!-- 上半部分：品牌与主要内容 -->
      <div class="footer-main">
        <div class="footer-brand-section">
          <h2 class="brand-name">成都胥大网络科技有限公司</h2>
          <p class="brand-slogan">致力于提供卓越的数字化解决方案</p>
          <div class="footer-links">
            <a href="/" class="footer-link">首页</a>
            <a href="/product" class="footer-link">产品中心</a>
            <a href="/solution" class="footer-link">解决方案</a>
            <a href="/about" class="footer-link">关于我们</a>
          </div>
        </div>

        <div class="footer-contact-section">
          <div class="contact-item">
            <i class="icon">phone</i>
            <div class="contact-content">
              <span class="label">服务热线</span>
              <a href="tel:15762212286" class="value">15762212286</a>
            </div>
          </div>
          <div class="contact-item">
            <i class="icon">mail</i>
            <div class="contact-content">
              <span class="label">企业邮箱</span>
              <a href="mailto:313097897@qq.com" class="value">313097897@qq.com</a>
            </div>
          </div>
          <div class="contact-item">
            <i class="icon">location</i>
            <div class="contact-content">
              <span class="label">公司地址</span>
              <span class="value">中国（四川）自由贸易试验区成都市天府新区兴隆街道湖畔路北段269号1栋5楼7号</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 下半部分：版权与备案 -->
      <div class="footer-bottom">
        <div class="copyright-info">
          <span>© 2026 成都胥大网络科技有限公司 版权所有</span>
          <span class="divider">|</span>
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="beian-link">
            蜀ICP备19041648号-1
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter',
};
</script>

<style scoped lang="scss">
.footer {
  --footer-bg: #1a1d21;
  --text-main: #ffffff;
  --text-muted: #a9aeb8;
  --accent-color: #3491fa;
  --border-color: #31353b;

  background-color: var(--footer-bg);
  color: var(--text-main);
  padding: 64px 0 32px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;

  .footer-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 24px;
  }

  .footer-main {
    display: flex;
    justify-content: space-between;
    gap: 60px;
    padding-bottom: 40px;
    border-bottom: 1px solid var(--border-color);
  }

  /* 品牌区 */
  .footer-brand-section {
    flex: 1;

    .brand-name {
      font-size: 24px;
      font-weight: 600;
      margin: 0 0 12px;
      color: var(--text-main);
    }

    .brand-slogan {
      color: var(--text-muted);
      font-size: 14px;
      margin-bottom: 32px;
    }

    .footer-links {
      display: flex;
      gap: 24px;

      .footer-link {
        color: var(--text-muted);
        text-decoration: none;
        font-size: 15px;
        transition: color 0.2s ease;

        &:hover {
          color: var(--accent-color);
        }
      }
    }
  }

  /* 联系区 */
  .footer-contact-section {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 24px;

    .contact-item {
      display: flex;
      gap: 16px;
      align-items: flex-start;

      .icon {
        font-style: normal;
        background: rgba(255, 255, 255, 0.05);
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        color: var(--accent-color);
        font-size: 14px;
        /* 这里使用简易文字代替图标，建议项目中使用SVG */
        &::before {
          content: '●';
        }
      }

      .contact-content {
        display: flex;
        flex-direction: column;
        gap: 4px;

        .label {
          font-size: 12px;
          color: var(--text-muted);
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .value {
          font-size: 15px;
          color: var(--text-main);
          text-decoration: none;
          line-height: 1.5;
          transition: color 0.2s;

          &[href]:hover {
            color: var(--accent-color);
          }
        }
      }
    }
  }

  /* 底部版权区 */
  .footer-bottom {
    padding-top: 32px;
    display: flex;
    justify-content: center;
    text-align: center;

    .copyright-info {
      font-size: 13px;
      color: var(--text-muted);
      display: flex;
      align-items: center;
      gap: 12px;
      flex-wrap: wrap;
      justify-content: center;

      .divider {
        color: var(--border-color);
      }

      .beian-link {
        color: var(--text-muted);
        text-decoration: none;
        transition: color 0.2s;

        &:hover {
          color: var(--text-main);
          text-decoration: underline;
        }
      }
    }
  }

  /* 响应式调整 */
  @media (max-width: 860px) {
    padding: 48px 0 24px;

    .footer-main {
      flex-direction: column;
      gap: 40px;
      text-align: center;
    }

    .footer-brand-section {
      .footer-links {
        justify-content: center;
      }
    }

    .footer-contact-section {
      .contact-item {
        flex-direction: column;
        align-items: center;
        gap: 8px;
      }
    }

    .footer-bottom {
      .copyright-info {
        flex-direction: column;
        gap: 8px;

        .divider {
          display: none;
        }
      }
    }
  }
}
</style>
